// Shared helpers for EditEntryPanel.jsx — the right-side edit drawer.

/** Build the initial formData snapshot from a claim record. Also reused
 *  as `originalData` for unsaved-changes detection. */
export function mapClaimToForm(claim) {
  if (!claim) return {};
  const bool = (v) => v === true || v === 'true';
  return {
    company_name: claim.company_name || '',
    date_of_loss: claim.date_of_loss ? claim.date_of_loss.split('T')[0] : '',
    drivers_name: claim.drivers_name || '',
    drivers_ph_no: claim.drivers_ph_no || '',
    truck_no: claim.truck_no || '',
    trailer_no: claim.trailer_no || '',
    location: claim.location || '',
    description: claim.description || '',
    al: claim.al || false,
    pd: claim.pd || false,
    cd: claim.cd || false,
    ocac: claim.ocac || false,
    wc: claim.wc || false,
    other_vehicle_involved: claim.other_vehicle_involved || '',
    fault: claim.fault || '',
    driver_charged: claim.driver_charged || '',
    deductible: claim.deductible || false,
    deductible_amount: claim.deductible_amount || '',
    other_amount_checked: claim.other_amount_checked || false,
    other_amount: claim.other_amount || '',
    police_involved:
      claim.police_involved === true ? 'Yes' : claim.police_involved === false ? 'No' : '',
    police_report_no: claim.police_report_no || '',
    police_report_not_ready: claim.police_report_not_ready || false,
    citation: claim.citation || '',
    injury: bool(claim.injury),
    tow_away: bool(claim.tow_away),
    fatality: bool(claim.fatality),
    damage_pics: bool(claim.damage_pics),
    other_vehicle_docs: bool(claim.other_vehicle_docs),
    other_cmv: bool(claim.other_cmv),
    pr_or_ef: bool(claim.pr_or_ef),
    our_truck_docs: bool(claim.our_truck_docs),
    video_footage: bool(claim.video_footage),
    drivers_ws: bool(claim.drivers_ws),
    estimates: bool(claim.estimates),
    other_docs: bool(claim.other_docs),
    log_books: bool(claim.log_books),
    da_test: bool(claim.da_test),
  };
}

export const PROPER_FIELDS = ['drivers_name', 'location'];
export const SENTENCE_FIELDS = ['description'];

export const LOSS_TYPE_CHECKS = [
  { key: 'al', label: 'AL' },
  { key: 'pd', label: 'PD' },
  { key: 'cd', label: 'CD' },
  { key: 'ocac', label: 'OCAC' },
  { key: 'wc', label: 'WC' },
];

export const DOC_FIELDS_BASE = [
  { label: 'Pictures Of Vehicle / Property Damage(s)', field: 'damage_pics' },
  { label: 'DL or CDL, Insurance, Registration of Other Vehicle', field: 'other_vehicle_docs' },
  { label: 'Police Report # or Exchange Form', field: 'pr_or_ef' },
  { label: 'Company Truck Reg., Lease Agreement, Rate Con., BOL', field: 'our_truck_docs' },
  { label: 'Video Footage', field: 'video_footage' },
  { label: 'Drivers Written Statement', field: 'drivers_ws' },
  { label: 'Damage Repair Estimate(s)', field: 'estimates' },
  { label: 'Other Supporting Docs', field: 'other_docs' },
  { label: '"Log Books"', field: 'log_books' },
  { label: 'Drug & Alcohol Test Results', field: 'da_test' },
];

export function buildDocFields(otherVehicleInvolved) {
  if (otherVehicleInvolved === 'CMV') {
    return [
      DOC_FIELDS_BASE[0],
      DOC_FIELDS_BASE[1],
      { label: 'DOT#, Truck#, Plate#, Trailer# of Other CMV', field: 'other_cmv' },
      ...DOC_FIELDS_BASE.slice(2),
    ];
  }
  return DOC_FIELDS_BASE;
}

export const isImageName = (name) => /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(name || '');

/** Validate the at-fault/police gating rules before saving. Returns a list of
 *  human-readable missing-field names — empty when valid. */
export function validateBeforeSave(formData) {
  const missing = [];
  if (formData.fault === 'At Fault' && !formData.driver_charged) {
    return ['Driver Charged'];
  }
  if (formData.police_involved === 'Yes') {
    if (!formData.citation) missing.push('Citation Issued');
    if (!formData.police_report_not_ready && !formData.police_report_no?.trim()) {
      missing.push('Police Report #');
    }
  }
  return missing;
}
